import * as stagesSettlement from "../../Stages/StagesSettlement";
import { translate } from "../../Translations/translatorService";
import { PaymentTypeSwitchData } from "../../../types/ProductService/ProductService";
import { Settlement } from "../../../types/Products/EmploymentLaw/Settlement";

export const paymentTypeSwitchDataSettlement: PaymentTypeSwitchData<Settlement> = {
  getPaymentSwitchAllowed: () => {
    return { allowed: true };
  },
  getActionAvailable: (product: Settlement) => {
    if (!product.stage) {
      return false;
    }
    return (
      product.paymentType === "insurance" &&
      product.stage >= stagesSettlement.STAGE_CHECKED &&
      product.stage <= stagesSettlement.STAGE_DATE_SET_TRIAL
    );
  },
  options: [
    { value: "private", label: translate("settlement.paymentType.values.private"), disabled: false },
    {
      value: "nwnf",
      label: translate("settlement.paymentType.values.nwnf"),
      disabled: false,
    },
    { value: "insurance", label: translate("settlement.paymentType.values.insurance"), disabled: true },
  ],
};
